import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action — pass id string/number, or `{ id, silent: true }` for background refresh (no loading spinner)
export const fetchDiscountApprovalDetail = createAsyncThunk("fetchDiscountApprovalDetail", async (arg, { rejectWithValue }) => {
	const isOpts = arg && typeof arg === "object" && "id" in arg;
	const id = isOpts ? arg.id : arg;
	try {
		const response = await axiosHttp.get(`discount-request/${id}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching detail");
	}
});

const DiscountApprovalDetailSlice = createSlice({
	name: "DiscountApprovalDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDiscountApprovalDetail.pending, (state, action) => {
			const arg = action.meta.arg;
			const silent = Boolean(arg && typeof arg === "object" && arg.silent);
			if (!silent) {
				state.isLoading = true;
			}
		});

		builder.addCase(fetchDiscountApprovalDetail.fulfilled, (state, action) => {
			const arg = action.meta.arg;
			const silent = Boolean(arg && typeof arg === "object" && arg.silent);
			if (!silent) {
				state.isLoading = false;
			}
			state.data = action.payload;
		});

		builder.addCase(fetchDiscountApprovalDetail.rejected, (state, action) => {
			const arg = action.meta.arg;
			const silent = Boolean(arg && typeof arg === "object" && arg.silent);
			if (!silent) {
				state.isLoading = false;
				state.error = action.payload || action.error.message || "Unknown error occurred";
			}
		});
	},
});

export default DiscountApprovalDetailSlice.reducer;
